import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    background: #FFFFFF;
    font-family: Mulish;
    padding: 22px 18px;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-thumb { background-color: #BABABA; border-radius: 5px; }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;
    padding-bottom: 18px;
    border-bottom: 1px solid #EEF1F6;
`;

export const Avatar = styled.div`
    width: 84px;
    height: 84px;
    border-radius: 50%;
    background: ${(props) => props.$color || "#2F80ED"};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 1.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img { width: 100%; height: 100%; object-fit: cover; }
`;

export const Name = styled.h3`
    margin: 6px 0 0;
    font-size: 1.05rem;
    font-weight: 800;
    color: #2B3240;
`;

export const Members = styled.span`
    color: #9AA4B2;
    font-size: 0.8rem;
`;

export const Actions = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 10px;
`;

export const ActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #E3E8F0;
    background: #FFFFFF;
    color: #2F80ED;
    font-family: Mulish;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 6px 12px;
    border-radius: 8px;
    cursor: pointer;

    &:disabled { opacity: 0.55; cursor: not-allowed; }
    svg { font-size: 0.9rem; }
`;

export const Section = styled.div`
    padding: 16px 0;
    border-bottom: 1px solid #EEF1F6;

    &:last-child { border-bottom: none; }
`;

export const SectionHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SectionTitle = styled.h4`
    margin: 0 0 12px;
    font-size: 0.95rem;
    font-weight: 800;
    color: #2B3240;
`;

export const SeeAll = styled.span`
    color: #2F80ED;
    font-size: 0.78rem;
    font-weight: 700;
    opacity: 0.6;
    cursor: default;
`;

export const StatGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
`;

export const StatCard = styled.div`
    border: 1px solid #EEF1F6;
    border-radius: 10px;
    padding: 10px 12px;
    min-height: 58px;
`;

export const StatLabel = styled.div`
    color: #9AA4B2;
    font-size: 0.66rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02em;
`;

export const StatValue = styled.div`
    color: #2B3240;
    font-size: 1.35rem;
    font-weight: 800;
    margin-top: 2px;
`;

export const ComingSoon = styled.div`
    color: #B7BEC9;
    font-size: 0.8rem;
    font-style: italic;
    margin-top: 4px;
`;

export const MemberRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 0;
`;

export const MemberAvatar = styled.div`
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: ${(props) => props.$color || "#2F80ED"};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 0.72rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MemberInfo = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const MemberName = styled.span`
    font-weight: 700;
    color: #2B3240;
    font-size: 0.84rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const MemberRole = styled.span`
    color: #9AA4B2;
    font-size: 0.72rem;
`;

export const PinnedCard = styled.div`
    position: relative;
    background: #FFF8E6;
    border-radius: 10px;
    padding: 10px 28px 10px 12px;
    margin-top: 8px;
`;

export const PinnedTitle = styled.div`
    font-weight: 800;
    font-size: 0.8rem;
    color: #B7791F;
    margin-bottom: 2px;
`;

export const PinnedBody = styled.div`
    font-size: 0.82rem;
    color: #5B4A2A;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const PinnedRemove = styled.button`
    position: absolute;
    top: 6px;
    right: 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #B7BEC9;
    display: inline-flex;
    font-size: 0.95rem;

    &:hover { color: #8A94A6; }
`;
